export default "__VITE_ASSET__ababc1fe__"